export default "__VITE_ASSET__3u4p5qLV__"